import React from 'react';
import { MMDDYYYYFormat } from '../UI/DateFormats';
import { Translate } from 'react-localize-redux';
import { Tooltip } from 'antd';

export class ClickableReviewText extends React.Component {
	showModal = (appUserId, sku) => {
		this.fetchUserTitleReview(appUserId, sku);
		this.props.setUserTitleReviewModalState({
			reviewRetrieving: true,
		});
	};

	fetchUserTitleReview(appUserId, sku) {
		let baseUrl = process.env.REACT_APP_API_URL;
		let userTitleReviewUrl = `${baseUrl}/api/v1/affiliations/${
			this.props.communityId
		}/user/${appUserId}/review/${sku}?reviewsCreatedDateMaxDaysBack=${
			this.props.reviewsCreatedDateMaxDaysBack
		}`;
		fetch(userTitleReviewUrl, {
			method: 'POST',
			headers: { 'Access-Control-Allow-Origin': '*' },
			credentials: 'include',
			mode: 'cors',
		})
			.then(response => response.json())
			.then(data => {
				let createdDate = new Date(data.review.createdDate);
				let userInfo = data.usersById[appUserId];
				let productInfo = data.productsBySku[sku];
				let userAvatar = data.userAvatarsByAppUserId[appUserId];

				let orgName = '';
				if (
					data.organizationsById.hasOwnProperty(
						userInfo.orgID.toLowerCase(),
					)
				) {
					let orgInfo =
						data.organizationsById[userInfo.orgID.toLowerCase()];
					if (orgInfo.hasOwnProperty('displayName')) {
						orgName = orgInfo.displayName;
					}
				}

				this.props.setUserTitleReviewModalState({
					appUserId: appUserId,
					titleName: productInfo.name,
					reviewText: data.review.text,
					rating: data.review.rating,
					userAvatar: userAvatar,
					userName: userInfo.fullName,
					createdDate: createdDate.toLocaleDateString(
						'en-US',
						MMDDYYYYFormat,
					),
					orgName: orgName,
					assessments: data.assessments,
					reviewRetrieving: false,
					visible: true,
				});
			})
			.catch(err => console.log(err));
	}

	renderReviewTextAnchor() {
		const { appUserId, sku } = this.props;
		return (
			<div
				className="clickable dotDot review-text anchor"
				onClick={() => this.showModal(appUserId, sku)}>
				<Tooltip title="Read the review">
					{this.props.reviewText}
				</Tooltip>
			</div>
		);
	}

	renderNoReviewTextPrompt() {
		return (
			<div className="dotDot review-text">
				<em>
					<Translate id="no_review_written" />
				</em>
			</div>
		);
	}

	render() {
		const { reviewText } = this.props;
		const hasText = typeof reviewText === 'string' && reviewText.length > 0;

		return (
			<div className="clickable-review-text">
				{hasText
					? this.renderReviewTextAnchor()
					: this.renderNoReviewTextPrompt()}
			</div>
		);
	}
}
